import React from 'react';
import { Container } from 'react-bootstrap';
import RatioVideo from './RatioVideo';

const Video = () => {
  return (
    <div className="page-content">
        <Container fluid>
            <RatioVideo />
        </Container>
    </div>
  )
}

export default Video